import modal from './src/';
import confirm from './confirm';

export default modal;



// WEBPACK FOOTER //
// ./src/components/modal/index.js